export interface IGlobalState {
    loading: boolean;
    initialized: boolean;
}

export enum Types {
    SET_GLOBAL_STATE = "SET_GLOBAL_STATE",
    SET_LOADING = "SET_LOADING",
    SET_INITIALIZED = "SET_INITIALIZED",
}